<template>
    <div>
        <app-data-table
            :fields="fields"
            :items="items"
        >
            <template slot="actions" slot-scope="{ item }">
                <b-btn variant="primary" v-if="userCan('update-structure')" @click="edit(item)"><i class="fa fa-edit"></i></b-btn>
                <b-btn variant="danger" v-if="userCan('delete-structure')" @click="startRemove(item)"><i class="fa fa-times"></i></b-btn>
            </template>
        </app-data-table>
        <app-pop-up
            title="Edición de Puesto"
            size="large"
            id="service-spot-form"
        >
            <template slot="body">
                <app-client-service-spot-form
                    v-if="!!selectedSpot"
                    ref="serviceSpotForm"
                    :item="selectedSpot"
                    @saved="onSave"
                    :the-client="client"
                    :venues="venues"
                    :service-spot-types="serviceSpotTypes"
                ></app-client-service-spot-form>
            </template>
            <template slot="buttons">
                <b-btn variant="confirm" @click="update">
                    <i class="fa fa-save"></i> Guardar
                </b-btn>
            </template>
        </app-pop-up>
    </div>
</template>
<script>
import serviceSpotRepository from '@repositories/serviceSpot.repository';
import ClientServiceSpotForm from '../ClientServiceSpotForm/ClientServiceSpotForm';
export default {
    components: {
        appClientServiceSpotForm: ClientServiceSpotForm
    },
    props: {
        items: {
            type: Array,
            required: true
        },
        serviceSpotTypes: {
            type: Array,
            default: () => []
        },
        venues: {
            type: Array,
            default: () => []
        } 
    },
    data: () => ({
        fields: [
            {
                key: 'name',
                label: 'Puesto'
            },
            {
                key: 'service_spot_type.name',
                label: 'Tipo'
            },
            {
                key: 'venue.name',
                label: 'Sede'
            },
            {
                key: 'actions',
                label: 'Acciones'
            },
        ],
        selectedSpot: ''
    }),
    methods: {
        edit(spot) {
            this.selectedSpot = spot;
            this.$bus.$emit('service-spot-form.open');
        },
        update() {
            this.$refs.serviceSpotForm.save();
        },
        startRemove(item) {
            this.$dialog.confirm(`Esta seguro de eliminar el puesto ${item.name}?`)
            .then(dialog => {
                this.remove(item);
            })
            .catch();
        },
        async remove(spot) {
            const sr = {...serviceSpotRepository};

            try {
                const { data } = await sr.delete(spot.id);
                toastr.success('Puesto eliminado');
                this.$emit('delete', spot);
            } catch(err) {
                this.handleErrors(err);
            }
        },
        onSave(spot) {
            this.selectedSpot = '';
            this.$emit('saved', spot);
            this.$bus.$emit('service-spot-form.close');
        }
    }
}
</script>